import React from 'react';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { useTranslation } from 'hooks/useTranslation';

import { CustomDatePicker } from '../CustomDatePicker';

import { useStyles } from './styles';

export type RangeDatePickerProps = {
  startDate?: Date | null;
  endDate?: Date | null;
  onStartDateChange: (date: MaterialUiPickersDate) => void;
  onEndDateChange: (date: MaterialUiPickersDate) => void;
};

export const RangeDatePicker = ({ startDate, endDate, onStartDateChange, onEndDateChange }: RangeDatePickerProps) => {
  const classes = useStyles();
  const { t } = useTranslation('app');

  return (
    <div className={classes.rangeDatePickerContainer}>
      <CustomDatePicker value={startDate} onChange={onStartDateChange} title={t('from')} maxDate={endDate} />
      <CustomDatePicker value={endDate} onChange={onEndDateChange} title={t('to')} minDate={startDate} />
    </div>
  );
};
